import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { ShopifyLocaleCode } from '@portal/schema/locale';
import { getShopifyLocale } from '@portal/shared/utils/locale';
import { StoreCode } from 'schema/storeCode';
import { getCartUrl } from '../queries/cartUrl';
import { shopifyFetch } from '../utils';

export async function fetchShopifyCartUrl(
  storeCode: StoreCode,
  cartId: string,
  locale: keyof typeof ShopifyLocaleCode
): Promise<string> {
  const res = await shopifyFetch<any>({
    query: getCartUrl,
    shopifyDomain: SHOPIFY_STORE_DOMAIN[storeCode],
    accessToken: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    variables: { id: cartId }
  });

  const checkoutUrl = res.body.data?.cart?.checkoutUrl;
  if (!checkoutUrl) {
    throw new Error('Cart not found or missing checkoutUrl');
  }

  const checkoutUrlWithLocale = new URL(checkoutUrl);
  const shopifyLocale = getShopifyLocale(locale);
  checkoutUrlWithLocale.searchParams.set('locale', shopifyLocale);

  return checkoutUrlWithLocale.toString();
}
